/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { Row } from "@tanstack/react-table";
import { MoreHorizontal } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { StoreEmailEditModal } from "../edit";
// import { UserEditModal } from "../edit";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const { handleModal } = useDialogModal();
  console.log(row);
  const handleOpenModal = () => {
    handleModal({
      isOpen: true,
      element: <StoreEmailEditModal row={{ original: row.original }} />,
      title: "Editar Emails de Loja",
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost_none"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted border-none bg-transparent"
        >
          <MoreHorizontal />
          <span className="sr-only">Abrir Menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem onClick={() => handleOpenModal()}>
          Editar
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
